import { CommonModule }         from '@angular/common';
import { FormsModule }          from '@angular/forms';
import { NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule }             from '@angular/core';
import { TranslateModule }      from '@ngx-translate/core';

import { DirectivesModule }    from '../directives/directives.module';
import { FlipperComponent }    from './flipper/flipper.component';
import { IconComponent }       from './icon/icon.component';
import { ImageViewModule }     from './image-viewer/image-viewer.module';
import { ListBoxComponent }    from './list-box/list-box.component';
import { WizardComponent }     from './wizard/wizard.component';
import { WizardStepComponent } from './wizard/wizard.step.component';

@NgModule({
  declarations: [
    FlipperComponent,
    IconComponent,
    ListBoxComponent,
    WizardComponent,
    WizardStepComponent
  ],
  entryComponents: [
    FlipperComponent,
    IconComponent,
    ListBoxComponent,
    WizardComponent,
    WizardStepComponent
  ],
  exports: [
    CommonModule,
    FormsModule,

    FlipperComponent,
    IconComponent,
    ImageViewModule,
    ListBoxComponent,
    WizardComponent,
    WizardStepComponent
  ],
  imports: [
    // Angular
    CommonModule,
    FormsModule,

    //Third Party
    NgbProgressbarModule,
    TranslateModule,

    //Custom
    DirectivesModule,
    ImageViewModule
  ]
})
export class ComponentsModule {}
